import * as _ from "lodash";
import * as moment from 'moment';
import { Component, FormEvent } from 'react';
import { connect, Dispatch } from "react-redux";
import { IApplicationState, ISwapState, SwapActionCreators, AppActionCreators, SwapActionTypes, IAppState, IAvailableRecipientListResponse, IAvailableRecipient, NetworkEmailActionCreators, ISendEmailRequest } from "@nkr/store/index";
import { ICluster, IClusterListResponse, IBaseResponse, IMatchHistoryRecipient, IListItem, IPosition, ICenterBase } from "@nkr/models/index";
import { ChainStatus, ClusterStatus, MatchHistoryType, EmailStatusType } from "@nkr/enums/index";
import { ISwapCountResponse } from "../../models";
import { TableHeadWrapper, TableWrapper } from "../../styles";
import { Button, ButtonGroup, ToggleButtonGroup, ToggleButton, FormControl, InputGroup, Alert, Well, Row } from "react-bootstrap";
import MediaQuery from "react-responsive";
import { toast } from "react-toastify";
import SwapListRow from "./swap-list-row";
import SwapListRowMobile from "./swap-list-row-mobile";
import Actions from "./actions";
import { AxiosError } from "axios";
import SwapManagerChange from "./swap-manager-change";
import SwapManagement from '../swap-management';
import { SwapManagementAction } from '../swap-management/swap-managerment-action';
import { Utility } from '@nkr/services/utility';
import { ActionTypes } from "./actions/models";
import SwapMatchOfferEmail from "./swap-match-offer-email";
import Legend from './legend';

interface IOwnProps {
    chainStatusId: number,
    clusterStatusId: number
}

interface IStateProps {
    swaps: ISwapState,
    app: IAppState
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    showAlert: (title: string, message: string | JSX.Element) => void,
    getCounts: () => Promise<ISwapCountResponse>,
    setSwaps: (list: ICluster[]) => void,
    getSwaps: (chainStatus: number, status: number, refreshPage: boolean) => Promise<IClusterListResponse>,
    getSwapsByChainId: (chainId: number) => Promise<IClusterListResponse>,
    saveChainStatus: (chainId: number, chainStatus: number) => Promise<IBaseResponse>,
    saveClusterStatus: (clusterId: number, clusterStatus: number) => Promise<IBaseResponse>,
    saveLogisticsProvider: (clusterId: number, logisticsProvider: number) => Promise<IBaseResponse>,
    saveSwapManager: (clusterId: number, swapManager: string, chainId: number, updateAllClustersInChain: boolean) => Promise<IBaseResponse>,
    saveLogisticsDateTime: (clusterId: number, logisticsDateTime: string) => Promise<IBaseResponse>,
    saveKickoffDateTime: (clusterId: number, kickoffDateTime: string) => Promise<IBaseResponse>,
    saveChainMatchHistoryDeadline: (matchHistoryType: MatchHistoryType, clusterId: number, deadlineDateTime: string, list: IMatchHistoryRecipient[]) => Promise<IBaseResponse>,
    saveComment: (clusterId: number, comment: string) => Promise<IBaseResponse>,
    bridgeDonor: (donorId: number, chainId: number) => Promise<IBaseResponse>,
    unBridgeDonor: (donorId: number, chainId: number) => Promise<IBaseResponse>,
    convertToVoucher: (donorId: number, originalChainId: number, newChainId: number) => Promise<IBaseResponse>,
    cancelCluster: (clusterId: number, firstDonorId: number) => Promise<IBaseResponse>,
    removeRecipientFromCluster: (clusterId: number, recipientId: number) => Promise<IBaseResponse>,
    removePairFromCluster: (clusterId: number, positionNumber: number, recipientId: number, bridgeDonorId: number) => Promise<IBaseResponse>,
    replaceRecipientInCluster: (clusterId: number, recipientId: number, replacementRecipientId: number, bridgeDonorId: number) => Promise<IBaseResponse>,
    replacePairInCluster: (clusterId: number, currentBridgeDonorId: number, replacementRecipientId: number, bridgeDonorId: number) => Promise<IBaseResponse>,
    addRecipientToCluster: (clusterId: number, positionNumber: number, recipientId: number, bridgeDonorId: number) => Promise<IBaseResponse>,
    getAvailableRecipients: () => Promise<IAvailableRecipientListResponse>,
    commenceMatchOffer: (clusterId: number, deadline: string, forceTargetSurgeryDate: boolean, positions: number[], clcPositions: number[], matchOfferType: number, sendEmail: boolean) => Promise<IBaseResponse>,
    sendImmediateEmail: (type: number, clusterId: number, date: string, realtimeSwapFailure: boolean, useStreamlinedCancellation: boolean, preselectReversal: boolean, prereversalResponsibles: any[], sendEmail: boolean) => Promise<IBaseResponse>,
    sendNetworkEmails: (request: ISendEmailRequest) => Promise<IBaseResponse>
}

type TProps =
    IOwnProps
    & IStateProps
    & IDispatchProps;

interface ISwapListState {
    collapseStatus: number,
    mapUrl: string,
    isInitialPageLoading: boolean;
    actions: {
        show: boolean,
        swap: ICluster | null,
        rccapSwaps: ICluster[]
    },
    detailedSwaps: number[],
    exportable: number,
    swapManagerChange: {
        show: boolean,
        data: {
            clusterId: number,
            chainId: number,
            clusterNumber: number,
            swapManager: string
        }
    },
    swapManagementModal: {
        show: boolean,
        chainId: number,
        data: IPosition[]
    },
    swapEmailSidePanel: {
        show: boolean,
        drawerEmailParams: {
            mode: string;
            id: string;
            deadline: string,
            positions: string;
            useStreamlinedCancellation: number;
            realTimeSwapFailure: number;
            preselectReversal: number;
            prereversalResponsibles: string;
            extra: string;
        }
    },
    actionType: number,
    chainId: string,
    sortOrder: {
        index: number,
        clusterId: number,
        chainId: number,
        clusterNumber: number
    }[],
    availableRecipients: IAvailableRecipient[],
    availableRecipientCenterList: ICenterBase[],
    swapsToProcess: number[]
}

const initialState: ISwapListState = {
    collapseStatus: 0,
    mapUrl: "",
    isInitialPageLoading: true,
    actions: {
        show: false,
        swap: null,
        rccapSwaps: []
    },
    detailedSwaps: [],
    exportable: -1,
    swapManagerChange: {
        show: false,
        data: null
    },
    swapManagementModal: {
        show: false,
        chainId: 0,
        data: []
    },
    swapEmailSidePanel: {
        show: false,
        drawerEmailParams: {
            mode: '',
            id: '',
            deadline: '',
            positions: '',
            useStreamlinedCancellation: -1,
            realTimeSwapFailure: -1,
            preselectReversal: -1,
            prereversalResponsibles: '',
            extra: '',
        }
    },
    actionType: -1,
    chainId: '',
    sortOrder: [],
    availableRecipients: [],
    availableRecipientCenterList: [],
    swapsToProcess: []
};

const clusterStatusList: IListItem[] = [
    { id: 0, description: "All", abbreviation: "" },
    { id: 1, description: "Stalled", abbreviation: "" },
    { id: 2, description: "Offers", abbreviation: "" },
    { id: 3, description: "Donor Clearance", abbreviation: "" },
    { id: 4, description: "Kickoff", abbreviation: "" },
    { id: 5, description: "No Match", abbreviation: "" },
    { id: 6, description: "XPlanted", abbreviation: "" },
    { id: 7, description: "Logistics", abbreviation: "" },
    { id: 8, description: "In-Process", abbreviation: "" },
    { id: 10, description: "ID", abbreviation: "" },
];

class SwapList extends Component<TProps, ISwapListState> {
    readonly state: ISwapListState = initialState;
    ifr: any = null;

    componentWillMount = () => {
        this.setState({
            exportable: this.props.clusterStatusId == 1 ? 1 : -1
        });
    }

    componentDidMount = () => {
        let clusterStatus = clusterStatusList.find(x => x.id == this.props.clusterStatusId);

        document.title = `NKR Admin: ${clusterStatus != null ? clusterStatus.description : "All"}`;
    }

    componentDidUpdate = (prevProps: Readonly<TProps>, prevState: Readonly<ISwapListState>, snapshot?: any) => {
        if (prevProps.swaps.list.length == 0 && this.props.swaps.list.length > 0) {

            this.setState({ isInitialPageLoading: false });

            if (this.props.clusterStatusId == ClusterStatus.Offers) {
                let sortOrder = this.props.swaps.list.map(x => {
                    return {
                        index: x.sortOrder,
                        clusterId: x.id,
                        chainId: x.chainId,
                        clusterNumber: x.clusterNumber
                    };
                });

                this.setState({
                    sortOrder
                });
            }
        }
    }

    handleExpandAll = () => {
        let detailedSwaps = this.props.swaps.list.map(s => s.id);

        this.setState({
            detailedSwaps
        });
    }

    handleCollapseAll = () => {
        this.setState({
            detailedSwaps: []
        });
    }

    handleToggleAll = () => {
        let allIds = this.props.swaps.list.map(s => s.id);
        let { detailedSwaps } = this.state;

        let isAllExpanded = detailedSwaps.length === allIds.length;

        this.setState({
            detailedSwaps: isAllExpanded ? [] : allIds
        });
    };

    handleShowMap = (url: string) => {
        window.open(url);
    }

    handleUpdateAfterResetMatchOffer = (emailStatusType: EmailStatusType) => {
        Promise.all([
            this.props.getCounts(),
            this.props.getSwaps(this.props.chainStatusId, this.props.clusterStatusId, false)
        ])
            .then(([countResponse, swapsDataResponse]) => {
                if (countResponse.data.success && swapsDataResponse.data.success) {
                    let list = swapsDataResponse.data.results;
                    let swapsToProcess = _.cloneDeep(this.state.swapsToProcess);

                    const updatedSwaps = list.map(swap => {
                        if (this.state.swapsToProcess.includes(swap.id)) {
                            const updatedPositions = swap.positions.map(pos => {
                                pos.emailStatus = emailStatusType
                                return pos;
                            });

                            swapsToProcess = swapsToProcess.filter(swapId => swapId != swap.id)
                            return { ...swap, positions: updatedPositions };
                        }
                        return swap;
                    });

                    this.props.setSwaps(updatedSwaps);

                    this.setState({
                        swapsToProcess
                    });
                }
            })
            .finally(() => {
                this.props.hideLoading();
            });
    }

    handleUpdateAfterReset = () => {
        this.props.showLoading("Reloading swaps, one moment please...").then(() => {
            this.props.setSwaps([]);

            return Promise.all(
                [
                    this.props.getCounts(),
                    this.props.getSwaps(this.props.chainStatusId, this.props.clusterStatusId, true)
                ]).then((response: any) => {
                    this.props.hideLoading();
                });
        });
    }

    handleShowActions = (swap: ICluster) => {
        let rccapSwaps = this.props.swaps.list.filter(x => x.chainId == swap.chainId);

        this.setState({
            actions: {
                show: true,
                swap: swap,
                rccapSwaps
            }
        });
    }

    handleCloseActions = () => {
        this.setState({
            actions: { ...this.state.actions, show: false }
        });
    }

    handleCloseAndReloadActions = (actionType: number, emailStatusType: EmailStatusType) => {
        if (actionType == ActionTypes.MatchOffer || actionType == ActionTypes.CancelSwap)
            this.handleUpdateAfterResetMatchOffer(emailStatusType);
        else {
            this.setState({
                actions: { ...this.state.actions, show: false }
            }, () => {
                this.handleUpdateAfterReset();
            });
        }
    }

    handleCommenceMatchOfferImmediately = (swapId: number, clusterId: number, deadline: string, forceTargetSurgeryDate: boolean, positions: number[], clcPositions: number[], matchOfferType: number, sendEmail: boolean) => {
        const updatedSwaps = this.props.swaps.list.map(swap => {
            if (swap.id == swapId) {
                const updatedPositions = swap.positions.map(pos => {
                    pos.emailStatus = EmailStatusType.Sending
                    return pos;
                });
                return { ...swap, positions: updatedPositions };
            }
            return swap;
        });

        this.props.setSwaps(updatedSwaps);

        let swapsToProcess = _.cloneDeep(this.state.swapsToProcess);
        swapsToProcess.push(swapId);

        this.setState({
            swapsToProcess
        })

        this.props.commenceMatchOffer(clusterId, deadline, forceTargetSurgeryDate, positions, clcPositions, matchOfferType, true)
            .then(response => {
                if (response.data.success) {
                    setTimeout(() => {
                        this.handleCloseAndReloadActions(ActionTypes.MatchOffer, EmailStatusType.Sent);
                    }, 500);
                }
            })
            .finally(() => {
                this.props.hideLoading();
            });
    }

    handleCancelOfferImmediately = (swapId: number, type: number, clusterId: number, date: string, realtimeSwapFailure: boolean, useStreamlinedCancellation: boolean, preselectReversal: boolean, prereversalResponsibles: any[]) => {
        let updatedSwaps = this.props.swaps.list.map(swap => {
            if (swap.id == swapId) {
                let updatedPositions = swap.positions.map(pos => {
                    pos.emailStatus = EmailStatusType.Cancelling
                    return pos;
                });

                return { ...swap, positions: updatedPositions };
            }

            return swap;
        });

        this.props.setSwaps(updatedSwaps);

        let swapsToProcess = _.cloneDeep(this.state.swapsToProcess);
        swapsToProcess.push(swapId);

        this.setState({
            swapsToProcess
        })

        this.props.sendImmediateEmail(type, clusterId, date, realtimeSwapFailure, useStreamlinedCancellation, preselectReversal, prereversalResponsibles, true)
            .then(response => {
                if (response.data.success) {
                    setTimeout(() => {
                        this.handleCloseAndReloadActions(ActionTypes.CancelSwap, EmailStatusType.Cancelled);
                    }, 500);
                }
            })
            .finally(() => {
                this.props.hideLoading();
            });
    }

    handleCommenceMatchOffer = () => {
        this.setState({
            actions: { ...this.state.actions, show: false }
        }, () => {
            this.updateSwaps('Match offer sent', true, true);
        });
    }

    handleChainStatusChange = (swapType: string, chainId: number, chainStatus: number) => {
        this.props.showLoading("Updating chain status, one moment please...").then(() => {
            this.props.saveChainStatus(chainId, chainStatus)
                .then((response: IBaseResponse) => {
                    if (response.data.success) {
                        this.updateSwaps("Chain status updated!", true, true);
                    }
                })
                .catch((error: AxiosError) => {
                    this.props.hideLoading();

                    this.props.showAlert(
                        "End " + swapType,
                        <>
                            <div className="text-center" style={{ marginBottom: 20 }}>Unfortunately, we are unable to end the {swapType.toLowerCase()}...</div>
                            <div className="text-center text-danger">Reason:&nbsp;{error.response.data}</div>
                        </>
                    );
                });
        });
    }

    handleClusterStatusChange = (clusterId: number, clusterStatus: number) => {
        this.props.showLoading("Updating cluster status, one moment please...").then(() => {
            this.props.saveClusterStatus(clusterId, clusterStatus).then((response: IBaseResponse) => {
                if (response.data.success)
                    this.updateSwaps("Cluster status updated!", true, true);
            });
        });
    }

    handleSwapManagerChange = (clusterId: number, swapManager: string) => {
        let cluster = this.props.swaps.list.find(x => x.id == clusterId);

        this.setState({
            swapManagerChange: {
                show: true,
                data: {
                    clusterId,
                    chainId: cluster.chainId,
                    clusterNumber: cluster.clusterNumber,
                    swapManager
                }
            }
        });
    }

    handleCancelSwapManagerChange = () => {
        this.setState({
            swapManagerChange: {
                show: false,
                data: null
            }
        });
    }

    handleSaveSwapManagerChange = (updateAllClustersInChain: boolean) => {
        let { clusterId, swapManager, chainId } = this.state.swapManagerChange.data;

        this.setState({
            swapManagerChange: {
                show: false,
                data: null
            }
        }, () => {
            this.props.showLoading("Updating swap manager, one moment please...").then(() => {
                this.props.saveSwapManager(clusterId, swapManager, chainId, updateAllClustersInChain).then((response: IBaseResponse) => {
                    if (response.data.success)
                        this.updateSwaps("Swap manager updated!", true, false);
                });
            });
        });
    }

    handleLogisticsProviderChange = (clusterId: number, logisticsProvider: number) => {
        this.props.showLoading("Updating logistics provider, one moment please...").then(() => {
            this.props.saveLogisticsProvider(clusterId, logisticsProvider).then((response: IBaseResponse) => {
                if (response.data.success)
                    this.updateSwaps("Logistics provider updated!", true, false);
            });
        });
    }

    handleChainDeadlineDateTimeChange = (matchHistoryType: MatchHistoryType, clusterId: number, deadlineDateTime: string, list: IMatchHistoryRecipient[]) => {
        var loadingText = matchHistoryType == MatchHistoryType.MatchOffer ? "Updating match offer deadline, one moment please..." : "Updating donor clearance deadline, one moment please...";
        var toastText = matchHistoryType == MatchHistoryType.MatchOffer ? "Match offer deadline recorded!" : "Donor clearance deadline recorded!";

        this.props.showLoading(loadingText).then(() => {
            this.props.saveChainMatchHistoryDeadline(matchHistoryType, clusterId, deadlineDateTime, list).then((response: IBaseResponse) => {
                if (response.data.success)
                    this.updateSwaps(toastText, true, false);
            });
        });
    }

    handleKickoffDateTimeChange = (clusterId: number, kickoffDateTime: string) => {
        this.props.showLoading("Updating kickoff call date/time, one moment please...").then(() => {
            this.props.saveKickoffDateTime(clusterId, kickoffDateTime).then((response: IBaseResponse) => {
                if (response.data.success)
                    this.updateSwaps("Kickoff call date/time updated!", true, false);
            });
        });
    }

    handleLogisticsDateTimeChange = (clusterId: number, logisticsDateTime: string) => {
        this.props.showLoading("Updating logistics call date/time, one moment please...").then(() => {
            this.props.saveLogisticsDateTime(clusterId, logisticsDateTime).then((response: IBaseResponse) => {
                if (response.data.success)
                    this.updateSwaps("Logistics call date/time updated!", true, false);
            });
        });
    }

    handleSaveComment = (clusterId: number, comment: string) => {
        this.props.saveComment(clusterId, comment).then((response: IBaseResponse) => {
            if (response.data.success)
                this.updateSwaps("Comment updated!", true, false);
        });
    }

    handleShowDetail = (id: number) => {
        let detailedSwaps = _.cloneDeep(this.state.detailedSwaps);
        let found = detailedSwaps.indexOf(id) >= 0;

        if (found) {
            detailedSwaps = detailedSwaps.filter(s => s != id);
        } else {
            detailedSwaps.push(id);
        }

        this.setState({
            detailedSwaps
        });
    }

    handleShowSwapManagementModal = async (chainId: number) => {
        this.props.showLoading('Getting chain information, one moment please...').then(async () => {
            let availableRecipientResponse = await this.props.getAvailableRecipients();
            let { recipientList: availableRecipients, centerList: availableRecipientCenterList } = availableRecipientResponse.results;
            let response = await this.props.getSwapsByChainId(chainId);
            let positions = response.data.results.flatMap(x => x.positions); //.map((position, index) => ({ ...position, index, highlight: false, isNotCurrent: true }));

            this.setState({
                availableRecipients,
                availableRecipientCenterList,
                swapManagementModal: {
                    show: true,
                    chainId,
                    data: positions
                }
            }, () => {
                this.props.hideLoading();
            });
        });
    }

    handleSwapManagementModalAction = (action: SwapManagementAction, clusterForAction: number, positionForAction: number, donorForAction: number, recipientForAction: number, replacementRecipientId: number, bridgeDonorId: number) => {
        let chainId = this.state.swapManagementModal.chainId;

        if (action == SwapManagementAction.Bridge) {
            this.props.showLoading('Bridging donor, one moment please...').then(() => {
                this.props.bridgeDonor(donorForAction, chainId)
                    .then(async response => {
                        if (response.data.success) {
                            this.updateSwaps('Donor bridged successfully', true, true, true);
                            this.updateSwapManagement();
                        } else {
                            this.props.hideLoading();
                        }
                    })
                    .catch(error => {
                        toast.error(error.response.data, { autoClose: false });
                        this.props.hideLoading();
                    });
            });
        }

        if (action == SwapManagementAction.Unbridge) {
            this.props.showLoading('Unbridging donor, one moment please...').then(() => {
                this.props.unBridgeDonor(donorForAction, chainId)
                    .then(response => {
                        if (response.data.success) {
                            this.updateSwaps('Donor unbridged successfully', true, true);
                            this.updateSwapManagement();
                        } else {
                            this.props.hideLoading();
                        }
                    })
                    .catch(error => {
                        toast.error(error.response.data, { autoClose: false });
                        this.props.hideLoading();
                    });
            });
        }

        if (action == SwapManagementAction.NewChainAsVoucher) {
            this.props.showLoading('Creating new voucher chain, one moment please...').then(() => {
                this.props.convertToVoucher(donorForAction, chainId, null)
                    .then(response => {
                        if (response.data.success) {
                            this.updateSwaps('New voucher chain created successfully', true, true);
                            this.updateSwapManagement();
                        }
                    })
                    .catch(error => {
                        toast.error(error.response.data, { autoClose: false });
                    })
                    .finally(() => {
                        this.props.hideLoading();
                    });
            });
        }

        if (action == SwapManagementAction.ResetCluster) {
            this.setState({
                swapManagementModal: {
                    show: false,
                    chainId: 0,
                    data: []
                }
            }, () => {
                this.props.showLoading('Cancelling cluster, one moment please...').then(() => {
                    this.props.cancelCluster(clusterForAction, donorForAction)
                        .then(response => {
                            if (response.data.success) {
                                this.updateSwaps('Cluster cancelled successfully', true, true);
                            }
                        })
                        .catch(error => {
                            toast.error(error.response.data, { autoClose: false });
                        })
                        .finally(() => {
                            this.props.hideLoading();
                        });
                });
            });
        }

        if (action == SwapManagementAction.RemoveRecipient) {
            this.props.showLoading('Removing recipient from cluster, one moment please...').then(() => {
                this.props.removeRecipientFromCluster(clusterForAction, recipientForAction)
                    .then(response => {
                        if (response.data.success) {
                            this.updateSwaps('Recipient removed from cluster successfully', true, true);
                            this.updateSwapManagement();
                        }
                    })
                    .catch(error => {
                        toast.error(error.response.data, { autoClose: false });
                    })
                    .finally(() => {
                        this.props.hideLoading();
                    });
            });
        }

        if (action == SwapManagementAction.RemovePair) {
            this.props.showLoading('Removing pair, one moment please...').then(() => {
                this.props.removePairFromCluster(clusterForAction, positionForAction, recipientForAction, donorForAction)
                    .then(response => {
                        if (response.data.success) {
                            this.updateSwaps('Pair removed successfully', true, true);
                            this.updateSwapManagement();
                        }
                    })
                    .catch(error => {
                        toast.error(error.response.data, { autoClose: false });
                    })
                    .finally(() => {
                        this.props.hideLoading();
                    });
            });
        }

        if (action == SwapManagementAction.ReplaceRecipient) {
            this.props.showLoading('Replacing recipient, one moment please...').then(() => {
                this.props.replaceRecipientInCluster(clusterForAction, recipientForAction, replacementRecipientId, bridgeDonorId)
                    .then(response => {
                        if (response.data.success) {
                            this.updateSwaps('Recipient replaced successfully', true, true);
                            this.updateSwapManagement();
                        }
                    })
                    .catch(error => {
                        toast.error(error.response.data, { autoClose: false });
                    })
                    .finally(() => {
                        this.props.hideLoading();
                    });
            });
        }

        if (action == SwapManagementAction.ReplacePair) {
            this.props.showLoading('Replacing pair, one moment please...').then(() => {
                this.props.replacePairInCluster(clusterForAction, donorForAction, replacementRecipientId, bridgeDonorId)
                    .then(response => {
                        if (response.data.success) {
                            this.updateSwaps('Pair replaced successfully', true, true);
                            this.updateSwapManagement();
                        }
                    })
                    .catch(error => {
                        toast.error(error.response.data, { autoClose: false });
                    })
                    .finally(() => {
                        this.props.hideLoading();
                    });
            });
        }

        if (action == SwapManagementAction.AddRecipient) {
            this.props.showLoading('Adding recipient, one moment please...').then(() => {
                this.props.addRecipientToCluster(clusterForAction, positionForAction, replacementRecipientId, bridgeDonorId)
                    .then(response => {
                        if (response.data.success) {
                            this.updateSwaps('Recipient added successfully', true, true);
                            this.updateSwapManagement();
                        }
                    })
                    .catch(error => {
                        toast.error(error.response.data, { autoClose: false });

                    })
                    .finally(() => {
                        this.props.hideLoading();
                    });
            });
        }
    }

    handleCloseSwapManagementModal = () => {
        this.setState({
            swapManagementModal: {
                show: false,
                chainId: 0,
                data: []
            }
        });
    }

    handleMatchOfferDeadline = () => {
        window.open('/manage-swaps/match-offer-deadlines');
    }

    handleDonorClearanceDeadline = () => {
        window.open('/manage-swaps/donor-clearance-deadlines');
    }

    handleBmDdr = () => {
        this.gotoBestMatch('bmx06');
    }

    handleBmSlow = () => {
        this.gotoBestMatch('bmslow');
    }

    handleActiveExportableChange = (value: number) => {
        this.setState({
            exportable: value
        });
    }

    handleChainFieldChange = (e: FormEvent<FormControl & HTMLInputElement>) => {
        this.setState({
            chainId: e.currentTarget.value
        });
    }

    handleSubmitChainSearch = () => {
        if (Utility.isNumber(this.state.chainId)) {
            this.props.showLoading('Finding chain, one moment please...').then(() => {
                this.props.getSwapsByChainId(parseInt(this.state.chainId)).then(response => {
                    this.props.hideLoading();
                    this.props.setSwaps(response.data.results);
                });
            });
        }
    }

    handleResetChainSearch = () => {
        this.setState({
            chainId: ''
        }, () => {
            this.props.setSwaps([]);
        });
    }

    handleCloseSidePanel = () => {
        this.setState({ swapEmailSidePanel: { ...this.state.swapEmailSidePanel, drawerEmailParams: null, show: false } });
    }

    handleShowSidePanel = (actionType: number, drawerEmailParams: any) => {
        this.setState({
            actionType
        }, () => {
            this.setState({
                swapEmailSidePanel: {
                    show: true,
                    drawerEmailParams
                }
            });
        })
    }

    handleSendNetworkEmail = (actionType: number, matchOfferType: number, dateTime: string, forceTargetSurgeyDates: boolean, request: ISendEmailRequest, testRecipientList: string[]) => {
        this.setState({
            swapEmailSidePanel: {
                ...this.state.swapEmailSidePanel,
                show: false
            }
        }, () => {
            // Update email statuses for matching swap
            const updatedSwaps = this.props.swaps.list.map(swap => {
                if (swap.id == request.id) {
                    const updatedPositions = swap.positions.map(pos => {
                        const isTest = testRecipientList.length > 0;

                        pos.emailStatus = isTest
                            ? EmailStatusType.SendingTest
                            : actionType == ActionTypes.MatchOffer
                                ? EmailStatusType.Sending
                                : actionType == ActionTypes.CancelSwap
                                    ? EmailStatusType.Cancelling
                                    : EmailStatusType.Sending;

                        return pos;
                    });

                    return { ...swap, positions: updatedPositions };
                }
                return swap;
            });

            this.props.setSwaps(updatedSwaps);
            const swapsToProcess = [...this.state.swapsToProcess, request.id];
            this.setState({ swapsToProcess });

            this.props.commenceMatchOffer(request.clusterId, dateTime, forceTargetSurgeyDates, request.positions, request.clcPositions, matchOfferType, false)
                .then(response => {
                    if (response.data.success) {
                        this.props.sendNetworkEmails(request)
                            .then(response => {
                                if (response.data.success) {
                                    setTimeout(() => {
                                        const isTest = testRecipientList.length > 0;
                                        let status;

                                        if (isTest) {
                                            status = EmailStatusType.SentTest;
                                        } else {
                                            status = actionType === ActionTypes.MatchOffer ? EmailStatusType.Sent : EmailStatusType.Cancelled;
                                        }

                                        this.handleCloseAndReloadActions(actionType, status);
                                    }, 500);
                                } else {
                                    toast.error(
                                        'Emails not sent successfully, error: ' + response.data.message
                                    );
                                }
                            })
                            .catch(error => {
                                toast.error('Unable to send emails, error: ' + error.message);
                            })
                            .finally(() => {
                                this.props.hideLoading();
                            });
                    }
                });
        });
    };

    updateSwaps = (message: string, success: boolean, refresh: boolean, isBridging: boolean = false) => {
        if (refresh) {
            this.props.getSwaps(this.props.chainStatusId, this.props.clusterStatusId, true).then(() => {
                this.props.hideLoading();
                this.showAlert(message, success);

                if (this.props.clusterStatusId == ClusterStatus.Offers) {
                    let sortOrder = _.cloneDeep(this.state.sortOrder);

                    if (sortOrder.length < this.props.swaps.list.length) {
                        let detailedSwaps = this.state.detailedSwaps;

                        let missing = this.props.swaps.list.filter(x => {
                            let f = sortOrder.find(s => s.clusterId == x.id && x.chainId == s.chainId && x.clusterNumber == s.clusterNumber);
                            return f == null;
                        });

                        missing.forEach((swap, index) => {
                            sortOrder.push({
                                index: (index + 1) * -1,
                                clusterId: swap.id,
                                chainId: swap.chainId,
                                clusterNumber: swap.clusterNumber
                            });

                            if (isBridging) {
                                detailedSwaps.push(swap.id);
                            }
                        });

                        sortOrder = _.sortBy(sortOrder, x => x.index);

                        this.setState({
                            sortOrder,
                            detailedSwaps
                        });
                    }
                }
            });
        } else {
            this.props.hideLoading();
            this.showAlert(message, success);
        }
    }

    updateSwapManagement = async () => {
        let { chainId } = this.state.swapManagementModal;

        let response = await this.props.getSwapsByChainId(chainId);
        let positions = response.data.results.flatMap(x => x.positions).map((position, index) => ({ ...position, index, highlight: false, isNotCurrent: true }));;

        let availableRecipientResponse = await this.props.getAvailableRecipients();
        let { recipientList: availableRecipients, centerList: availableRecipientCenterList } = availableRecipientResponse.results;

        this.setState({
            availableRecipients,
            availableRecipientCenterList,
            swapManagementModal: { ...this.state.swapManagementModal, data: positions }
        });
    }

    getClusterDeadlineLabel = () => {
        switch (this.props.clusterStatusId) {
            case ClusterStatus.Offers: return "MO Deadline";
            case ClusterStatus.CrossMatching: return "DC Deadline";
            case ClusterStatus.Logistics: return "Logistics Call";
            case ClusterStatus.Kickoff: return "Kickoff Call";
            default: return "";
        }
    }

    getFilteredSwaps = () => {
        if (this.state.exportable >= 0) {
            let exportable = this.state.exportable > 0 ? true : false;

            return this.props.swaps.list.filter(swap => {
                let totalPositions = swap.positions.length;
                let matchingPositions = 0;

                swap.positions.forEach(position => {
                    if (position.donor.isExportable == exportable)
                        matchingPositions++;
                });

                return totalPositions == matchingPositions;
            });
        } else {
            return this.props.swaps.list;
        }
    }

    getOrderedSwaps = (swaps: ICluster[]) => {
        if (this.state.sortOrder.length == swaps.length) {
            let currentSort: ICluster[] = [];
            let newSort: ICluster[] = [];

            this.state.sortOrder.forEach(item => {
                let s = swaps.find(x => x.id == item.clusterId && x.chainId == item.chainId && x.clusterNumber == item.clusterNumber);

                //find chains that are cluster 2+
                if (s.clusterNumber > 1) {

                    let hasParent = swaps.find(x => x.chainId == item.chainId && x.clusterNumber == (item.clusterNumber - 1)) != undefined;

                    //if they have a parent in the list, push them into list of their own.
                    //else we put them into the normal array.
                    if (hasParent) {
                        newSort.push(s);
                    } else {
                        currentSort.push(s);
                    }

                } else {
                    currentSort.push(s);
                }
            });

            if (newSort.length > 0) {
                //order the new list to make sure that we push them in order
                newSort = _.sortBy(newSort, [
                    x => x.chainId,
                    x => x.clusterNumber
                ]);

                //push them in after their parent
                newSort.forEach(item => {
                    let indexOfParent = currentSort.findIndex(x => x.chainId == item.chainId && x.clusterNumber == (item.clusterNumber - 1));

                    if (indexOfParent > -1) {
                        currentSort.splice(indexOfParent + 1, 0, item);
                    }
                })
            }

            return currentSort;
        } else {
            return _.sortBy(swaps, [
                swap => swap.sortOrder
            ]);
        }
    }

    gotoBestMatch = (site: string) => {
        let myDate = new Date();

        let month = myDate.getMonth() + 1;
        let monthFull = month.toString();

        if (month <= 9)
            monthFull = '0' + month.toString();

        let addBm = 'bm/';

        if (site == 'bmslow')
            addBm = '';

        let day = myDate.getDate();
        let dayFull = day.toString();

        if (day <= 9)
            dayFull = '0' + day.toString();

        let prettyDate = monthFull + dayFull;
        let codeRef = "a69Jb7Z2";
        let codeRef3 = codeRef.substring(0, 2) + prettyDate.charAt(3) + codeRef.substring(2, 4) + prettyDate.charAt(2) + codeRef.substring(4, 6) + prettyDate.charAt(1) + codeRef.substring(6, 8) + prettyDate.charAt(0);

        let url = `${__BM_SLOW_URL__}/${addBm}PgPre.aspx?objRef=${codeRef3.toString()}`;

        window.open(url, '_blank');
    }

    showAlert = (message: string, success: boolean) => {
        if (success)
            toast.success(message, {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 1500
            });
        else
            toast.warn(message, {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 5000
            });
    }

    renderLegend = (small: boolean) => {
        const { clusterStatusId } = this.props;

        return (
            <>
                <Well bsSize="small">
                    <Row>
                        {clusterStatusId != ClusterStatus.Stalled && (
                            <div style={{ display: 'flex', fontSize: small ? 10 : 12 }}>

                                {clusterStatusId == ClusterStatus.Offers && (
                                    <div
                                        title="Chain Starter with < five business days donation range."
                                        style={{ display: 'flex', alignItems: 'center', marginLeft: 20, marginRight: 30 }}
                                    >
                                        <div
                                            style={{
                                                height: 20,
                                                width: 20,
                                                backgroundColor: '#adadeb',
                                                border: '1px solid #ddd',
                                                marginRight: 5,
                                                borderRadius: 4
                                            }}
                                        />
                                        <div>CS &lt; 5 business days</div>
                                    </div>
                                )}

                                <div
                                    title="Voucher donor pending offer"
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        marginLeft: clusterStatusId !== ClusterStatus.Offers ? 20 : 0,
                                        marginRight: 30
                                    }}
                                >
                                    <div
                                        style={{
                                            height: 20,
                                            width: 20,
                                            backgroundColor: '#C83333',
                                            border: '1px solid #ddd',
                                            marginRight: 5,
                                            borderRadius: 4
                                        }}
                                    />
                                    <div>VDPO</div>
                                </div>

                                <div
                                    title="Voucher donor pending donation"
                                    style={{ display: 'flex', alignItems: 'center', marginRight: 30 }}
                                >
                                    <div
                                        style={{
                                            height: 20,
                                            width: 20,
                                            backgroundColor: '#ddd',
                                            border: '1px solid #ddd',
                                            marginRight: 5,
                                            borderRadius: 4
                                        }}
                                    />
                                    <div>VDPD</div>
                                </div>

                                <div
                                    title="Voucher recipient TXP before voucher donor donation"
                                    style={{ display: 'flex', alignItems: 'center', marginRight: 30 }}
                                >
                                    <div
                                        style={{
                                            height: 20,
                                            width: 20,
                                            backgroundColor: '#FF954D',
                                            border: '1px solid #FF954D',
                                            marginRight: 5,
                                            borderRadius: 4
                                        }}
                                    />
                                    <div>VR TXP &lt; VDD</div>
                                </div>

                                <div
                                    title="Outside donation range"
                                    style={{ display: 'flex', alignItems: 'center', marginRight: 30 }}
                                >
                                    <div
                                        style={{
                                            height: 20,
                                            width: 20,
                                            border: '2px solid rgb(255, 0, 0)',
                                            marginRight: 5,
                                            borderRadius: 4
                                        }}
                                    />
                                    <div>ODR</div>
                                </div>

                                <div
                                    title="Surgery date contention"
                                    style={{ display: 'flex', alignItems: 'center', marginRight: 30 }}
                                >
                                    <div
                                        style={{
                                            height: 20,
                                            width: 20,
                                            backgroundColor: 'yellow',
                                            border: '1px solid #ddd',
                                            marginRight: 5,
                                            borderRadius: 4
                                        }}
                                    />
                                    <div>SDC</div>
                                </div>

                                <div
                                    title="Red Eye"
                                    style={{ display: 'flex', alignItems: 'center', marginRight: 30 }}
                                >
                                    <div
                                        style={{
                                            height: 20,
                                            width: 20,
                                            backgroundColor: '#EF9A9A',
                                            border: '1px solid #ddd',
                                            marginRight: 5,
                                            borderRadius: 4
                                        }}
                                    />
                                    <div>RE</div>
                                </div>

                                <div
                                    title="Surgery date contention and red eye"
                                    style={{ display: 'flex', alignItems: 'center', marginRight: 50 }}
                                >
                                    <div
                                        style={{
                                            height: 20,
                                            width: 20,
                                            backgroundColor: '#4949F5',
                                            border: '1px solid #ddd',
                                            marginRight: 5,
                                            borderRadius: 4
                                        }}
                                    />
                                    <div>SDC + RE</div>
                                </div>
                            </div>
                        )}

                        {clusterStatusId == ClusterStatus.Stalled && (
                            <div style={{ display: 'flex', fontSize: small ? 10 : 12 }}>
                                <div
                                    title="Any AB donor, any A donor over the age of 55, or any B donor over the age of 65."
                                    style={{ display: 'flex', alignItems: 'center', marginLeft: 20, marginRight: 30 }}
                                >
                                    <div
                                        style={{
                                            height: 20,
                                            width: 20,
                                            backgroundColor: 'yellow',
                                            border: '1px solid #ddd',
                                            marginRight: 5,
                                            borderRadius: 4
                                        }}
                                    />
                                    <div>Any AB donor, any A donor over the age of 55, or any B donor over the age of 65.</div>
                                </div>

                                <div
                                    title="Donor is within 28 calendar days of the last day of their donation range"
                                    style={{ display: 'flex', alignItems: 'center', marginRight: 20 }}
                                >
                                    <div
                                        style={{
                                            height: 20,
                                            width: 20,
                                            backgroundColor: 'green',
                                            border: '1px solid #ddd',
                                            marginRight: 5,
                                            borderRadius: 4
                                        }}
                                    />
                                    <div>Donor is within 28 calendar days of the last day of their donation range</div>
                                </div>

                                <div
                                    title="Chain Starter with < five business days donation range."
                                    style={{ display: 'flex', alignItems: 'center', marginRight: 50 }}
                                >
                                    <div
                                        style={{
                                            height: 20,
                                            width: 20,
                                            backgroundColor: '#adadeb',
                                            border: '1px solid #ddd',
                                            marginRight: 5,
                                            borderRadius: 4
                                        }}
                                    />
                                    <div>CS &lt; 5 business days</div>
                                </div>
                            </div>
                        )}
                    </Row>
                </Well>
            </>
        );
    };

    getHighlightedClusters = (swaps: ICluster[]) => {
        let { clusterStatusId } = this.props;
        let { exportable } = this.state;

        let highlightList = [];

        if ((clusterStatusId == 1 && swaps.length > 0 && exportable == 1) || (clusterStatusId == 2 && swaps.length > 0)) {
            swaps.forEach(x => {
                let { positionNumber, donationStartDate, donationEndDate, donor } = x.positions[0];

                if (positionNumber == 1) {
                    if (this.isHighlightDateNeeded(donationStartDate, donationEndDate, donor.age, donor.bloodType, x) || x.positions[0].offerNowType == 2) {
                        highlightList.push(x.chainId);
                    }
                }
            })
        }

        return highlightList;
    }

    isHighlightDateNeeded = (startDate: string, endDate: string, age: number, bloodType: string, cluster: ICluster) => {
        let now = moment().clone().add(28, 'days');

        if (isNaN(age)) {
            age = 0;
        }

        let a = ['A', 'A1', 'A2'];
        let ab = ['AB', 'A1B', 'A2B'];

        if (startDate) {
            let startDateToMoment = moment(startDate).clone();

            if ((ab.includes(bloodType) || a.includes(bloodType)) && startDateToMoment.isSameOrBefore(now)) {
                if (ab.includes(bloodType)) {
                    return true;
                } else if (a.includes(bloodType) && age > 55) {
                    return true;
                }
            }
        }

        if (endDate) {
            let endDateToMoment = moment(endDate).clone();

            if (a.includes(bloodType) && endDateToMoment.isSameOrBefore(now)) {
                return true;
            }
        }

        if (moment(endDate).diff(moment(startDate), 'days') < 7 && cluster.note.toLowerCase() == 'offer') {
            return true;
        }

        return false;
    }

    getDrawerEmailParams = () => {
        const { actionType, swapEmailSidePanel } = this.state;
        return swapEmailSidePanel.drawerEmailParams;
    }

    render = () => {
        const clusterDeadlineLabel = this.getClusterDeadlineLabel();
        const swaps = this.getFilteredSwaps();
        const orderedSwaps = this.props.clusterStatusId === ClusterStatus.Stalled
            ? _.orderBy(this.getOrderedSwaps(swaps), [
                swap => swap.note?.toLowerCase() === 'offer' ? 0 : 1,
                swap => swap.note?.toLowerCase() === 'clearing' ? 0 : 1
            ])
            : this.getOrderedSwaps(swaps);
        const clusterStatus = clusterStatusList.find(x => x.id == this.props.clusterStatusId);
        const offerNowHighlights = this.getHighlightedClusters(swaps);
        const showOfferNow = offerNowHighlights.length > 0 && this.props.clusterStatusId < ClusterStatus.Offers;
        const templateParams = this.getDrawerEmailParams();

        const isAllExpanded =
            !this.state.isInitialPageLoading &&
            this.state.detailedSwaps.length == this.props.swaps.list.length;

        return (
            <div style={{ paddingTop: 0 }}>
                <MediaQuery minDeviceWidth={1024}>
                    {this.props.chainStatusId != ChainStatus.Ended ?
                        <div style={{
                            marginTop: 10,
                            marginBottom: 10, display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                            flexWrap: 'wrap',
                            gap: 10
                        }}>
                            <ButtonGroup>
                                <Button
                                    bsStyle={
                                        this.state.isInitialPageLoading
                                            ? "success"
                                            : isAllExpanded
                                                ? "primary"
                                                : "success"
                                    }
                                    onClick={this.handleToggleAll}
                                >
                                    {this.state.isInitialPageLoading
                                        ? "+ Expand All"
                                        : isAllExpanded
                                            ? "− Collapse All"
                                            : "+ Expand All"}
                                </Button>
                            </ButtonGroup>

                            <Legend clusterStatusId={this.props.clusterStatusId} small={false} />
                        </div>
                        :
                        <div style={{
                            marginTop: 10,
                            marginBottom: 10, display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                            flexWrap: 'wrap',
                            gap: 10
                        }}>
                            <ButtonGroup bsSize='sm'>
                                <Button
                                    bsStyle={
                                        this.state.isInitialPageLoading
                                            ? "success"
                                            : isAllExpanded
                                                ? "primary"
                                                : "success"
                                    }
                                    onClick={this.handleToggleAll}
                                >
                                    {this.state.isInitialPageLoading
                                        ? "+ Expand All"
                                        : isAllExpanded
                                            ? "− Collapse All"
                                            : "+ Expand All"}
                                </Button>
                            </ButtonGroup>

                            <Legend clusterStatusId={this.props.clusterStatusId} small={true} />

                            <InputGroup bsSize='sm'>
                                <InputGroup.Addon style={{ fontWeight: 600 }}>Chain&nbsp;ID:</InputGroup.Addon>
                                <FormControl
                                    style={{ width: 100, height: 'initial' }}
                                    value={this.state.chainId}
                                    onChange={this.handleChainFieldChange} />
                                <InputGroup.Button>
                                    <Button bsStyle='primary' onClick={this.handleSubmitChainSearch}>Submit</Button>
                                </InputGroup.Button>
                                <InputGroup.Button>
                                    <Button onClick={this.handleResetChainSearch}>Clear</Button>
                                </InputGroup.Button>
                            </InputGroup>
                        </div>
                    }
                </MediaQuery>

                <MediaQuery maxDeviceWidth={1023}>
                    <h4 style={{ marginTop: 0, marginBottom: 7 }}>{clusterStatus.description} Swaps</h4>

                    {this.props.chainStatusId != ChainStatus.Ended ?
                        <div style={{
                            marginTop: 10,
                            marginBottom: 10, alignItems: 'center',
                            flexWrap: 'wrap',
                            gap: 10
                        }}>
                            <ButtonGroup>
                                <Button
                                    bsSize="small"
                                    bsStyle={
                                        this.state.isInitialPageLoading
                                            ? "success"     // always green while loading
                                            : isAllExpanded
                                                ? "primary"
                                                : "success"
                                    }
                                    onClick={this.handleToggleAll}
                                >
                                    {this.state.isInitialPageLoading
                                        ? "+ Expand All"
                                        : isAllExpanded
                                            ? "− Collapse All"
                                            : "+ Expand All"}
                                </Button>
                            </ButtonGroup>

                            <ButtonGroup style={{ float: "right" }}>
                                <Button bsSize="small" onClick={this.handleBmSlow}>LOOPS</Button>
                            </ButtonGroup>
                        </div>
                        :
                        <div style={{
                            marginTop: 10,
                            marginBottom: 10, alignItems: 'center',
                            flexWrap: 'wrap',
                            gap: 10
                        }}>
                            <ButtonGroup>
                                <Button
                                    bsSize="small"
                                    bsStyle={
                                        this.state.isInitialPageLoading
                                            ? "success"     // always green while loading
                                            : isAllExpanded
                                                ? "primary"
                                                : "success"
                                    }
                                    onClick={this.handleToggleAll}
                                >
                                    {this.state.isInitialPageLoading
                                        ? "+ Expand All"
                                        : isAllExpanded
                                            ? "− Collapse All"
                                            : "+ Expand All"}
                                </Button>
                            </ButtonGroup>

                            <InputGroup bsSize='sm'>
                                <InputGroup.Addon>Chain&nbsp;ID:</InputGroup.Addon>
                                <FormControl
                                    style={{ width: 100, height: 'initial' }}
                                    value={this.state.chainId}
                                    onChange={this.handleChainFieldChange} />
                                <InputGroup.Button>
                                    <Button onClick={this.handleSubmitChainSearch}>Submit</Button>
                                </InputGroup.Button>
                                <InputGroup.Button>
                                    <Button onClick={this.handleResetChainSearch}>Reset</Button>
                                </InputGroup.Button>
                            </InputGroup>
                        </div>
                    }
                </MediaQuery>

                {this.props.clusterStatusId == 1 && (
                    <>
                        <MediaQuery minDeviceWidth={1024}>
                            <div className="stalled-buttons" style={{ marginBottom: 20 }}>
                                <ToggleButtonGroup type="radio" name="exportable" value={this.state.exportable}>
                                    <ToggleButton type="radio" value={1} onClick={() => this.handleActiveExportableChange(1)}>Active &amp; Exportable</ToggleButton>
                                    <ToggleButton type="radio" value={0} onClick={() => this.handleActiveExportableChange(0)}>Not Active</ToggleButton>
                                    <ToggleButton type="radio" value={-1} onClick={() => this.handleActiveExportableChange(-1)}>All</ToggleButton>
                                </ToggleButtonGroup>
                            </div>
                        </MediaQuery>

                        <MediaQuery maxDeviceWidth={1023}>
                            <div className="stalled-buttons" style={{ marginBottom: 20 }}>
                                <ToggleButtonGroup type="radio" name="exportable" value={this.state.exportable}>
                                    <ToggleButton style={{ padding: "5px 10px", fontSize: 12, lineHeight: 1.5 }} type="radio" value={1} onClick={() => this.handleActiveExportableChange(1)}>Active &amp; Exportable</ToggleButton>
                                    <ToggleButton style={{ padding: "5px 10px", fontSize: 12, lineHeight: 1.5 }} type="radio" value={0} onClick={() => this.handleActiveExportableChange(0)}>Not Active</ToggleButton>
                                    <ToggleButton style={{ padding: "5px 10px", fontSize: 12, lineHeight: 1.5 }} type="radio" value={-1} onClick={() => this.handleActiveExportableChange(-1)}>All</ToggleButton>
                                </ToggleButtonGroup>
                            </div>
                        </MediaQuery>
                    </>
                )}

                <MediaQuery minDeviceWidth={1366}>
                    <TableWrapper fontSize={12} className="condensed striped">
                        <TableHeadWrapper>
                            <tr>
                                <th style={{ width: "2%" }}></th>
                                <th style={{ width: "2.5%" }}>Type</th>
                                <th style={{ width: "10%" }}>Swap #</th>

                                {this.props.clusterStatusId != ClusterStatus.Stalled && this.props.clusterStatusId != ClusterStatus.Offers && (
                                    <th>Swap Status</th>
                                )}

                                <th>Cluster Status</th>
                                <th>Action</th>
                                <th>Range <strong hidden={!showOfferNow} style={{ backgroundColor: 'yellow' }}> Offer Soon</strong></th>
                                <th>Manager</th>
                                <th style={{ width: "15%" }}>Courier</th>

                                {(this.props.clusterStatusId == ClusterStatus.Offers || this.props.clusterStatusId == ClusterStatus.CrossMatching || this.props.clusterStatusId == ClusterStatus.Logistics || this.props.clusterStatusId == ClusterStatus.Kickoff) && (
                                    <th>{clusterDeadlineLabel}</th>
                                )}

                                {this.props.clusterStatusId == ClusterStatus.Stalled && (
                                    <th>Active</th>
                                )}

                                <th>Comments</th>
                            </tr>
                        </TableHeadWrapper>
                        <tbody>
                            {orderedSwaps.map(swap =>
                                <SwapListRow
                                    key={'tr-' + swap.id}
                                    swap={swap}
                                    chainStatusId={this.props.chainStatusId}
                                    clusterStatusId={this.props.clusterStatusId}
                                    collapseStatus={this.state.collapseStatus}
                                    showDetail={this.state.detailedSwaps.indexOf(swap.id) >= 0}
                                    user={this.props.app.user}
                                    offerNowHighlight={offerNowHighlights.includes(swap.chainId)}
                                    onShowMap={this.handleShowMap}
                                    onUpdateAfterReset={this.handleUpdateAfterReset}
                                    onShowActions={this.handleShowActions}
                                    onChainStatusChange={this.handleChainStatusChange}
                                    onClusterStatusChange={this.handleClusterStatusChange}
                                    onLogisticsProviderChange={this.handleLogisticsProviderChange}
                                    onSwapManagerChange={this.handleSwapManagerChange}
                                    onLogisticsDateTimeChange={this.handleLogisticsDateTimeChange}
                                    onKickoffDateTimeChange={this.handleKickoffDateTimeChange}
                                    onMatchHistoryDeadlineChange={this.handleChainDeadlineDateTimeChange}
                                    onCommentChange={this.handleSaveComment}
                                    onShowDetail={this.handleShowDetail}
                                    onShowSwapManagement={this.handleShowSwapManagementModal}
                                    onUpdateSwaps={this.updateSwaps}
                                />
                            )}

                            {orderedSwaps.length == 0 && !this.props.app.loading && (
                                <tr>
                                    <td colSpan={12} style={{ textAlign: 'center', padding: '12px' }}>
                                        <Alert bsStyle="warning" bsSize="sm" style={{ marginBottom: 0 }}>
                                            No records to display…
                                        </Alert>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </TableWrapper>
                    {this.props.chainStatusId == ChainStatus.Ended && orderedSwaps.length == 0 && (
                        <Alert bsStyle='warning' bsSize='sm' style={{ textAlign: 'center' }}>Please enter a chain ID in the field above...</Alert>
                    )}
                </MediaQuery>

                <MediaQuery minDeviceWidth={1024} maxDeviceWidth={1365}>
                    <TableWrapper fontSize={10} className="condensed striped">
                        <TableHeadWrapper>
                            <tr>
                                <th style={{ width: "2%" }}></th>
                                <th style={{ width: "2.5%" }}>Type</th>
                                <th style={{ width: "10%" }}>Swap #</th>

                                {this.props.clusterStatusId != ClusterStatus.Stalled && this.props.clusterStatusId != ClusterStatus.Offers && (
                                    <th>Swap Status</th>
                                )}

                                <th>Cluster Status</th>
                                <th>Action</th>
                                <th>Range <strong hidden={!showOfferNow} style={{ backgroundColor: 'yellow' }}> Offer Soon</strong></th>
                                <th>Manager</th>
                                <th style={{ width: "15%" }}>Courier</th>

                                {(this.props.clusterStatusId == ClusterStatus.Offers || this.props.clusterStatusId == ClusterStatus.CrossMatching || this.props.clusterStatusId == ClusterStatus.Logistics || this.props.clusterStatusId == ClusterStatus.Kickoff) && (
                                    <th>{clusterDeadlineLabel}</th>
                                )}

                                {this.props.clusterStatusId == ClusterStatus.Stalled && (
                                    <th>Active</th>
                                )}

                                <th>Comments</th>
                            </tr>
                        </TableHeadWrapper>
                        <tbody>
                            {orderedSwaps.map(swap =>
                                <SwapListRow
                                    key={'tr-' + swap.id}
                                    swap={swap}
                                    clusterStatusId={this.props.clusterStatusId}
                                    chainStatusId={this.props.chainStatusId}
                                    collapseStatus={this.state.collapseStatus}
                                    showDetail={this.state.detailedSwaps.indexOf(swap.id) >= 0}
                                    user={this.props.app.user}
                                    offerNowHighlight={offerNowHighlights.includes(swap.chainId)}
                                    onShowMap={this.handleShowMap}
                                    onUpdateAfterReset={this.handleUpdateAfterReset}
                                    onShowActions={this.handleShowActions}
                                    onChainStatusChange={this.handleChainStatusChange}
                                    onClusterStatusChange={this.handleClusterStatusChange}
                                    onLogisticsProviderChange={this.handleLogisticsProviderChange}
                                    onSwapManagerChange={this.handleSwapManagerChange}
                                    onLogisticsDateTimeChange={this.handleLogisticsDateTimeChange}
                                    onKickoffDateTimeChange={this.handleKickoffDateTimeChange}
                                    onMatchHistoryDeadlineChange={this.handleChainDeadlineDateTimeChange}
                                    onCommentChange={this.handleSaveComment}
                                    onShowDetail={this.handleShowDetail}
                                    onShowSwapManagement={this.handleShowSwapManagementModal}
                                    onUpdateSwaps={this.updateSwaps}
                                />
                            )}

                            {orderedSwaps.length == 0 && !this.props.app.loading && (
                                <tr>
                                    <td colSpan={12} style={{ textAlign: 'center', padding: '12px' }}>
                                        <Alert bsStyle="warning" bsSize="sm" style={{ marginBottom: 0 }}>
                                            No records to display…
                                        </Alert>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </TableWrapper>
                </MediaQuery>

                <MediaQuery maxDeviceWidth={1023}>
                    <TableWrapper fontSize={12} className="condensed striped">
                        <TableHeadWrapper>
                            <tr>
                                <th style={{ width: "2%" }}></th>
                                <th style={{ width: "2.5%" }}>Type</th>
                                <th style={{ width: "10%" }}>Swap #</th>

                                {this.props.clusterStatusId != ClusterStatus.Stalled && this.props.clusterStatusId != ClusterStatus.Offers && (
                                    <th>Swap Status</th>
                                )}

                                <th>Cluster Status</th>
                                <th>Action</th>
                                <th>Range <strong hidden={!showOfferNow} style={{ backgroundColor: 'yellow' }}> Offer Soon</strong></th>
                                <th>Manager</th>
                                <th style={{ width: "15%" }}>Courier</th>

                                {(this.props.clusterStatusId == ClusterStatus.Offers || this.props.clusterStatusId == ClusterStatus.CrossMatching || this.props.clusterStatusId == ClusterStatus.Logistics || this.props.clusterStatusId == ClusterStatus.Kickoff) && (
                                    <th>{clusterDeadlineLabel}</th>
                                )}

                                {this.props.clusterStatusId == ClusterStatus.Stalled && (
                                    <th>Active</th>
                                )}

                                <th>Comments</th>
                            </tr>
                        </TableHeadWrapper>
                        <tbody>
                            {orderedSwaps.map(swap =>
                                <SwapListRowMobile
                                    key={'tr-' + swap.id}
                                    swap={swap}
                                    chainStatusId={this.props.chainStatusId}
                                    clusterStatusId={this.props.clusterStatusId}
                                    collapseStatus={this.state.collapseStatus}
                                    showDetail={this.state.detailedSwaps.indexOf(swap.id) >= 0}
                                    offerNowHighlight={offerNowHighlights.includes(swap.chainId)}
                                    user={this.props.app.user}
                                    onShowMap={this.handleShowMap}
                                    onUpdateAfterReset={this.handleUpdateAfterReset}
                                    onShowActions={this.handleShowActions}
                                    onChainStatusChange={this.handleChainStatusChange}
                                    onClusterStatusChange={this.handleClusterStatusChange}
                                    onLogisticsProviderChange={this.handleLogisticsProviderChange}
                                    onSwapManagerChange={this.handleSwapManagerChange}
                                    onLogisticsDateTimeChange={this.handleLogisticsDateTimeChange}
                                    onKickoffDateTimeChange={this.handleKickoffDateTimeChange}
                                    onMatchHistoryDeadlineChange={this.handleChainDeadlineDateTimeChange}
                                    onCommentChange={this.handleSaveComment}
                                    onShowDetail={this.handleShowDetail}
                                    onUpdateSwaps={this.updateSwaps}
                                />
                            )}

                            {orderedSwaps.length == 0 && !this.props.app.loading && (
                                <tr>
                                    <td colSpan={12} style={{ textAlign: 'center', padding: '12px' }}>
                                        <Alert bsStyle="warning" bsSize="sm" style={{ marginBottom: 0 }}>
                                            No records to display…
                                        </Alert>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </TableWrapper>
                </MediaQuery>

                <Actions
                    show={this.state.actions.show}
                    data={this.state.actions.swap}
                    clusterStatusId={this.props.clusterStatusId}
                    rccapSwaps={this.state.actions.rccapSwaps}
                    onClose={this.handleCloseActions}
                    onCloseAndReload={this.handleCloseAndReloadActions}
                    onCommenceMatchOffer={this.handleCommenceMatchOffer}
                    commenceMatchOfferImmediately={this.handleCommenceMatchOfferImmediately}
                    cancelMatchOfferImmediately={this.handleCancelOfferImmediately}
                    showSidePanel={this.handleShowSidePanel}
                />

                <SwapManagerChange
                    show={this.state.swapManagerChange.show}
                    data={this.state.swapManagerChange.data}
                    onSave={this.handleSaveSwapManagerChange}
                    onCancel={this.handleCancelSwapManagerChange}
                />

                <SwapManagement
                    show={this.state.swapManagementModal.show}
                    chainId={this.state.swapManagementModal.chainId}
                    positions={this.state.swapManagementModal.data}
                    recipientList={this.state.availableRecipients}
                    centerList={this.state.availableRecipientCenterList}
                    isStandalone={false}
                    onAction={this.handleSwapManagementModalAction}
                    onClose={this.handleCloseSwapManagementModal}
                />

                <SwapMatchOfferEmail
                    show={this.state.swapEmailSidePanel.show}
                    actionType={this.state.actionType}
                    drawerEmailParams={templateParams}
                    onCancel={this.handleCloseSidePanel}
                    sendMatchOfferWithComments={this.handleSendNetworkEmail}
                />
            </div>
        )
    }
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        swaps: state.swaps,
        app: state.app
    };
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        showAlert: (title, message) => {
            dispatch(AppActionCreators.showAlert(title, message));
        },
        getCounts: () => {
            return dispatch(SwapActionCreators.getCounts());
        },
        setSwaps: (list) => {
            return dispatch(SwapActionCreators.setSwaps(list));
        },
        getSwaps: (chainStatus, status, refreshPage) => {
            return dispatch(SwapActionCreators.getSwaps(chainStatus, status, refreshPage));
        },
        getSwapsByChainId: (chainId) => {
            return dispatch(SwapActionCreators.getSwapsByChainId(chainId));
        },
        getAvailableRecipients: () => {
            return dispatch(SwapActionCreators.getAvailableRecipients());
        },
        saveChainStatus: (chainId, chainStatus) => {
            return dispatch(SwapActionCreators.saveChainStatus(chainId, chainStatus));
        },
        saveClusterStatus: (clusterId, clusterStatus) => {
            return dispatch(SwapActionCreators.saveClusterStatus(clusterId, clusterStatus));
        },
        saveSwapManager: (clusterId, swapManager, chainId, updateAllClustersInChain) => {
            return dispatch(SwapActionCreators.saveSwapManager(clusterId, swapManager, chainId, updateAllClustersInChain));
        },
        saveLogisticsProvider: (clusterId, logisticsProvider) => {
            return dispatch(SwapActionCreators.saveLogisticsProvider(clusterId, logisticsProvider));
        },
        saveLogisticsDateTime: (clusterId, logisticsDateTime) => {
            return dispatch(SwapActionCreators.saveClusterDateTime(SwapActionTypes.UPDATE_LOGISTICS_DATETIME, clusterId, logisticsDateTime));
        },
        saveKickoffDateTime: (clusterId, logisticsDateTime) => {
            return dispatch(SwapActionCreators.saveClusterDateTime(SwapActionTypes.UPDATE_KICKOFF_DATETIME, clusterId, logisticsDateTime));
        },
        saveChainMatchHistoryDeadline: (matchHistoryType, clusterId, deadlineDateTime, list) => {
            return dispatch(SwapActionCreators.saveChainMatchHistoryDeadline(matchHistoryType, clusterId, deadlineDateTime, list));
        },
        saveComment: (clusterId, comment) => {
            return dispatch(SwapActionCreators.saveComment(clusterId, comment));
        },
        bridgeDonor: (donorId, chainId) => {
            return dispatch(SwapActionCreators.bridgeDonor(donorId, chainId));
        },
        unBridgeDonor: (donorId, chainId) => {
            return dispatch(SwapActionCreators.unBridgeDonor(donorId, chainId));
        },
        convertToVoucher: (donorId, originalChainId, newChainId) => {
            return dispatch(SwapActionCreators.convertToVoucher(donorId, originalChainId, newChainId));
        },
        cancelCluster: (clusterId, firstDonorId) => {
            return dispatch(SwapActionCreators.cancelCluster(clusterId, firstDonorId));
        },
        removeRecipientFromCluster: (clusterId, recipientId) => {
            return dispatch(SwapActionCreators.removeRecipientFromCluster(clusterId, recipientId));
        },
        removePairFromCluster: (clusterId, positionNumber, recipientId, bridgeDonorId) => {
            return dispatch(SwapActionCreators.removePairFromCluster(clusterId, positionNumber, recipientId, bridgeDonorId));
        },
        replaceRecipientInCluster: (clusterId, recipientId, replacementRecipientId, bridgeDonorId) => {
            return dispatch(SwapActionCreators.replaceRecipientInCluster(clusterId, recipientId, replacementRecipientId, bridgeDonorId));
        },
        replacePairInCluster: (clusterId, currentBridgeDonorId, replacementRecipientId, bridgeDonorId) => {
            return dispatch(SwapActionCreators.replacePairInCluster(clusterId, currentBridgeDonorId, replacementRecipientId, bridgeDonorId));
        },
        addRecipientToCluster: (clusterId, positionNumber, recipientId, bridgeDonorId) => {
            return dispatch(SwapActionCreators.addRecipientToCluster(clusterId, positionNumber, recipientId, bridgeDonorId));
        },
        commenceMatchOffer: (clusterId, deadline, forceTargetSurgeryDate, positions, clcPositions, matchOfferType, sendEmail) => {
            return dispatch(SwapActionCreators.commenceMatchOffer(clusterId, deadline, forceTargetSurgeryDate, positions, clcPositions, matchOfferType, sendEmail));
        },
        sendNetworkEmails: (request) => {
            return dispatch(NetworkEmailActionCreators.sendEmails(request));
        },
        sendImmediateEmail: (type, id, date, realtimeSwapFailure, useStreamlinedCancellation, preselectReversal, prereversalResponsibles, sendEmail) => {
            return dispatch(SwapActionCreators.sendImmediateEmail(type, id, date, realtimeSwapFailure, useStreamlinedCancellation, preselectReversal, prereversalResponsibles, sendEmail))
        }
    };
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(SwapList);
